import React, { useMemo } from 'react'
import { FormattedDate, FormattedTime, useIntl } from 'react-intl'
import Icon from 'components/Icon'

const Event = ({ timestamp, body, title, last, meta }) => {
  const { type = null, retake = false } = meta || {}

  const children = useMemo(() => {
    let parts = body.split(/\[(.*?)\]/gi)

    for (var i = 1; i < parts.length; i += 2) {
      if (parts[i].startsWith('&')) {
        parts[i] = (
          <span key={`event-${timestamp}-part-${i}`} className="relative inline-flex items-center rounded-full border border-gray-300 px-2 py-0.5 text-xs mx-1">
            <span className="absolute shrink-0 flex items-center justify-center">
              <Icon icon="flag" className={retake ? 'text-yellow-400' : 'text-tertiary'} />
            </span>
            <span className="ml-3.5 font-medium text-gray-900">{ parts[i].substring(1) }</span>
          </span>
        )
      } else if (parts[i].startsWith('#')) {
        parts[i] = (
          <span key={`event-${timestamp}-part-${i}`} className="font-medium text-xs p-1 border border-gray-300 rounded-full px-2 py-0.5">{ parts[i] }</span>
        )
      } else if (parts[i].startsWith('!')) {
        parts[i] = (
          <span key={`event-${timestamp}-part-${i}`} className="relative inline-flex items-center rounded-full border border-gray-300 px-2 py-0.5 text-xs mx-1">
            <span className="absolute shrink-0 flex items-center justify-center">
              <Icon icon="user" className={retake ? 'text-yellow-400' : 'text-tertiary'} />
            </span>
            <span className="ml-3.5 font-medium text-gray-900">{ parts[i].substring(1) }</span>
          </span>
        )
      }
    }

    return (
      <span>{ parts }</span>
    )
  }, [body])


  return (
    <li>
      <div className="relative pb-8">
        { !last &&
          <span className={`absolute top-5 left-5 -ml-px h-full w-0.5 ${retake ? 'bg-yellow-400' : 'bg-gray-200'}`} aria-hidden="true"></span>
        }
        <div className="relative flex items-start space-x-3">
          <div>
            <div className="relative px-1 mx-3 mt-3">
              <div className={`h-2 w-2 rounded-full ring-4 ring-white ${retake ? 'bg-yellow-400' : 'bg-tertiary'}`} />
            </div>
          </div>
          <div className="min-w-0 flex-1 py-0">
            <div className="text-sm leading-6">
              <span className="mr-2">
                { children }
              </span>

              <span className="whitespace-nowrap text-gray-500 text-xs">
                <FormattedDate value={timestamp * 1000} /> <FormattedTime value={timestamp * 1000} />
              </span>
            </div>
          </div>
        </div>
      </div>
    </li>
  )
}

export default Event
